module.exports = __webpack_public_path__ + "static/media/horn.09cc890c.svg";